import React from 'react';
import LangSelector from '../../elements/LangSelector';

// import ruLang from "../../img/RU.svg";

const Head = props => {
	return <div className="decktop_header">
		<div className='desktop_lang_wrapper'><LangSelector/></div>
	</div>;
};

export default Head;
